import styled from "@emotion/styled";
import { PureComponent } from "react";

import { getActiveItems } from "helpers/side-navigation";
import { ISideNavigationItem } from "interfaces/sideNavigationItem";

import { SideNavigationItem } from "./SideNavigationItem";

interface IProps {
  items: ISideNavigationItem[];
  activeItemId?: string;
  activeItemCustomTitle?: string;
  onItemClick?(id?: string): void;
  onActiveItemUpdated?(item: ISideNavigationItem, customItemTitle: string): void;
}

interface IState {
  prevActiveItemId: string;
  activeItem: ISideNavigationItem;
  unfoldedItems: Record<string, boolean>;
}

const SideNavigationItems = styled.ul`
  box-sizing: border-box;
  margin: 0;
  padding: 24px 24px 10px;
  max-height: 100%;
  overflow-y: auto;
`;

export class SideNavigation extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    const { activeItem, activeParentItem } = getActiveItems(props.items, props.activeItemId);
    // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
    const unfoldedItems = activeParentItem ? { [activeParentItem.id]: true } : {};

    this.state = {
      // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      prevActiveItemId: props.activeItemId,
      activeItem,
      unfoldedItems,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    if (this.props.onActiveItemUpdated && this.state.activeItem) {
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      this.props.onActiveItemUpdated(this.state.activeItem, this.props.activeItemCustomTitle);
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.activeItemId !== prevState.prevActiveItemId) {
      const { activeItem, activeParentItem } = getActiveItems(nextProps.items, nextProps.activeItemId);

      if (!activeItem) {
        return null;
      }

      return {
        prevActiveItemId: nextProps.activeItemId,
        activeItem,
        unfoldedItems: {
          // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
          [activeParentItem.id]: true,
        },
      };
    }
    return null;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  componentDidUpdate(prevProps: any, prevState: any) {
    const isActiveItemChanged = prevState.activeItem !== this.state.activeItem;
    const isActiveItemTitleChanged = prevProps.activeItemCustomTitle !== this.props.activeItemCustomTitle;

    if ((isActiveItemChanged || isActiveItemTitleChanged) && this.props.onActiveItemUpdated) {
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      this.props.onActiveItemUpdated(this.state.activeItem, this.props.activeItemCustomTitle);
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(6133): 'e' is declared but its value is never read.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleItemToggle = (e: Event, id: string) => {
    this.setState(prevState => ({
      unfoldedItems: {
        ...prevState.unfoldedItems,
        [id]: !prevState.unfoldedItems[id],
      },
    }));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleItemClick = (id: string) => {
    if (this.props.onItemClick) {
      this.props.onItemClick(id);
    }
    this.unfoldItem(id);
  };

  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(6133): 'e' is declared but its value is never read.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleItemUnfold = (e: Event, id: string) => {
    this.unfoldItem(id);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  unfoldItem = (id: string) => {
    this.setState({
      unfoldedItems: {
        [id]: true,
      },
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { items, activeItemId } = this.props;

    return (
      <SideNavigationItems>
        {items.map(
          (item, index) =>
            !item.hidden && (
              <SideNavigationItem
                key={item.id || index}
                item={item}
                activeItemId={activeItemId}
                // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
                folded={!this.state.unfoldedItems[item.id]}
                onItemToggle={this.handleItemToggle}
                onItemClick={this.handleItemClick}
                onParentItemClick={this.handleItemUnfold}
              />
            )
        )}
      </SideNavigationItems>
    );
  }
}
